<template lang="pug">
.profile__activator(
  v-bind="$attrs"
  @click="isActive = !isActive"
)
  template(v-if="!mini")
    .profile__wrapper
      span {{ username | cropName }}
      template(v-if="municipality")
        span.body-2.redesignSecondary--text {{ municipality | cropName }}
  template(v-if="$user.isAuthenticated")
    user-avatar(
      :img="$user.profile && $user.profile.avatar && $user.profile.avatar.thumb"
      :username="username"
    )
  template(v-else)
    v-icon.profile__user-icon(
      color="redesignPrimaryDarken"
      :width="24"
    ) $iuser
  template(v-if="$user.isAuthenticated")
    v-icon.profile__expandIcon(
      :class="{ active: isActive }"
      :size="14"
    ) $ichevron-down
</template>

<script>
import UserAvatar from '../../UserAvatar.vue';

const MAX_NAME_LENGTH = 15;

export default {
  name: 'ProfileActivator',
  components: {
    UserAvatar,
  },
  filters: {
    cropName(value) {
      return value.length > MAX_NAME_LENGTH ? `${value.slice(0, MAX_NAME_LENGTH)}...` : value;
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    username() {
      if (!this.$user.isAuthenticated) {
        return 'Войти в профиль';
      }

      const { ROLES } = this.$conf;
      if (this.$user.hasRoles([ROLES.organization])) {
        return this.$user.data.organizer.full_name;
      }

      if (this.$user.hasRoles([ROLES.operator])) {
        return this.$user.data.region.name;
      }

      if (this.$user.hasRoles([ROLES.department])) {
        return this.$user.data.department.name;
      }

      if (this.$user.hasRoles([ROLES.member, ROLES.trainer, ROLES.expert, ROLES.certificate])) {
        if (!this.$user.profile.last_name || !this.$user.profile.first_name) {
          return this.$user.data.username;
        }

        const middleName = this.$user.profile.middle_name ? `${this.$user.profile.middle_name.slice(0, 1)}.` : '';

        return `${this.$user.profile.last_name} ${this.$user.profile.first_name.slice(0, 1)}. ${middleName}`;
      }

      return this.$user.data.username;
    },
    municipality() {
      if (!this.$user.isAuthenticated) {
        return null;
      }

      return this.$user?.profile?.municipality?.name || null;
    },
    isActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.profile {
  &__menu {
  }

  &__activator {
    height: 64px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 8px;
    transition: all 0.2s;
    font-size: 16px;
    line-height: 17px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }

    &:active {
      background: #f0f0f0;
    }
  }

  &__expandIcon {
    transition: all 0.2s;

    &.active {
      transform: rotate(180deg);
    }
  }

  &__user-icon {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      z-index: -1;
      width: 32px;
      height: 32px;
      background-color: #{$redesignPrimaryLighten};
      border-radius: 50%;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;

    small {
      font-size: 12px;
      color: #{$redesignSecondary};
    }
  }
}
</style>
